import React, { Suspense, useState } from 'react';
import Card from '@/components/card';
import Title from '@/components/title';
import SubMenu from '@/components/menu/sub-menu';
import { settingMenu } from '@/configs/menuItems';
import { getPathSegment } from '@/utils/pathUtils';
import { IImportData } from '@/interfaces/import';
import ImportDataTable from './components/import-data-table';
import { IDataModal } from '@/interfaces/dataModal';
import ImportProductModal from '@/components/import/product/import-product-modal';
import ImportCustomerModal from '@/components/import/customer/import-customer-modal';
import ImportStockModal from '@/components/import/stock/import-stock-modal';
import ImportShippingAddressModal from '@/components/import/shipping-address/import-shipping-address-modal';
import ImportCoaModal from '@/components/import/coa/import-coa-modal';

const _modal: IDataModal<IImportData> = {
  open: false,
};

const ImportData = () => {
  const pathSegment = getPathSegment();

  const [dataModal, setDataModal] = useState<IDataModal<IImportData>>(_modal);

  const data: IImportData[] = [
    {
      module: 'product',
      moduleName: 'สินค้า',
      templateFileName: 'product.xlsx',
    },
    {
      module: 'customer',
      moduleName: 'ลูกค้า',
      templateFileName: 'customer.xlsx',
    },
    {
      module: 'customer-shipto',
      moduleName: 'ที่อยู่ลูกค้า',
      templateFileName: 'customer-shipto.xlsx',
    },
    {
      module: 'stock',
      moduleName: 'สต็อก',
      templateFileName: 'stock.xlsx',
    },
    {
      module: 'coa',
      moduleName: 'COA',
      templateFileName: 'coa.xlsx',
    },
    {
      module: 'order',
      moduleName: 'ออเดอร์',
      templateFileName: 'order.xlsx',
    },
  ];
  return (
    <>
      <SubMenu active={pathSegment} items={settingMenu} />
      <Card customClass="min-h-[200px]">
        <Title title="นำเข้าข้อมูล" />
        <ImportDataTable
          loading={false}
          importData={data || []}
          onImport={function (data: IImportData): void {
            setDataModal({
              open: true,
              id: data.module,
              item: data,
            });
          }}
        />
      </Card>
      <Suspense>
        {dataModal?.open && dataModal?.id === 'product' && (
          <ImportProductModal
            open={dataModal?.open}
            handleOk={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
            handleCancel={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
          />
        )}
        {dataModal?.open && dataModal?.id === 'customer' && (
          <ImportCustomerModal
            open={dataModal?.open}
            handleOk={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
            handleCancel={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
          />
        )}
        {dataModal?.open && dataModal?.id === 'stock' && (
          <ImportStockModal
            open={dataModal?.open}
            handleOk={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
            handleCancel={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
          />
        )}
        {dataModal?.open && dataModal?.id === 'customer-shipto' && (
          <ImportShippingAddressModal
            open={dataModal?.open}
            handleOk={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
            handleCancel={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
          />
        )}
        {dataModal?.open && dataModal?.id === 'coa' && (
          <ImportCoaModal
            open={dataModal?.open}
            handleOk={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
            handleCancel={function (): void {
              setDataModal({
                ..._modal,
              });
            }}
          />
        )}
      </Suspense>
    </>
  );
};

export default ImportData;
